import { getApps, initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const requiredConfig = [
  'apiKey',
  'authDomain',
  'projectId',
  'appId',
];

export const getFirebaseAuth = () => {
  const missing = requiredConfig.filter((key) => !firebaseConfig[key]);
  if (missing.length) {
    throw new Error(
      `Admin Google sign-in is not configured. Missing Firebase settings: ${missing.join(', ')}. Restart the admin server after updating its environment file.`
    );
  }

  const app = getApps()[0] || initializeApp(firebaseConfig);
  return getAuth(app);
};

export const getGoogleProvider = () => {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: 'select_account' });
  return provider;
};
